export default {
  title: "Reset Password",
  description: "Create a new password for your account",
  newPassword: "New password",
  confirmPassword: "Confirm password",
  submit: "Reset Password",
  processing: "Processing...",
  validatingToken: "Validating your request...",
  invalidToken: "Invalid reset link",
  tokenExpiredOrInvalid: "The password reset link has expired or is invalid",
  requestNewLink: "You will need to request a new password reset link",
  backToLogin: "Back to login",
  successTitle: "Password reset successful!",
  successDetail: "Your password has been successfully updated.",
  redirecting: "Redirecting to login page...",
  invalidRequest: "Invalid request. Please check the reset link and try again.",
  genericError: "An error occurred while resetting your password. Please try again later.",
  successMessage: "Your password has been reset successfully. You will be redirected to login.",
  requirements: "Password requirements:",
  reqMinLength: "At least 8 characters",
  reqUppercase: "At least one uppercase letter",
  reqLowercase: "At least one lowercase letter",
  reqNumber: "At least one number",
  reqSpecial: "At least one special character",
  passwordsDoNotMatch: "Passwords do not match",
  passwordsMatch: "Passwords match",
  
  // Specific messages for different token errors
  tokenExpired: "The password reset link has expired",
  tokenExpiredDescription: "The time limit to use this password reset link has ended. Please request a new link.",
  tokenAlreadyUsed: "This link has already been used",
  tokenAlreadyUsedDescription: "This reset link has already been used previously to reset a password. For security reasons, each link can only be used once.",
  invalidTokenDescription: "The reset link you are trying to use is invalid. Please check if you copied the link correctly from the email or request a new one.",
  errorResetting: "Error resetting password",
  sessionCleared: "Session cleared for security"
} as const;
